import { render, staticRenderFns } from "./ProductInStockOrder.vue?vue&type=template&id=989666d4&scoped=true"
import script from "./ProductInStockOrder.vue?vue&type=script&lang=js"
export * from "./ProductInStockOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductInStockOrder.vue?vue&type=style&index=0&id=989666d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989666d4",
  null
  
)

export default component.exports